<template>
  <div class="home">
    <p class="title">{{ title }}</p>
    <div class="van-hairline--bottom"></div>
    <div class="content" v-if="!special">
      <p v-for="(li, index) in lists" :key="index">{{ li }}</p>
      <img class="ans_img" :src="'/tutorial/static/img/' + position + '01.png'" alt="" onerror="this.style.display='none'">
      <p v-for="(li, index) in lists2" :key="index">{{ li }}</p>
      <img v-if="lists2.length" class="ans_img" :src="'/tutorial/static/img/' + position + '02.png'" alt="">
      <p v-for="(li, index) in lists3" :key="index">{{ li }}</p>
      <img v-if="lists3.length" class="ans_img" :src="'/tutorial/static/img/' + position + '03.png'" alt="">
    </div>
    <div class="content" v-else>
      <p v-for="(li, index) in lists" :key="index">{{ li }}</p>
      <p v-for="(li, index) in lists2" :key="index" class="special_p1">
        {{ li }}
      </p>
        <img class="special" :src="'/tutorial/static/img/2/0202/en01.png'" alt="" onerror="this.style.display='none'">
      <p v-for="(li, index) in lists3" :key="index" class="special_p2">
        {{ li }}
      </p>
        <img class="special" :src="'/tutorial/static/img/2/0202/en02.png'" alt="">
    </div>
    <div class="feedback">
      <a @click.prevent="toFeedback">{{ $t('faq.p193') }}</a>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src

export default {
  name: 'home',
  data () {
    return {
      title: '',
      lists: [],
      lists2: [],
      lists3: [],
      special: false
    }
  },
  methods: {
    toFeedback () {
      location.replace('/feedback.html' + location.search)
      // location.replace('http://47.90.98.99:8082/feedback.html' + location.search)
    },
    getUrlParam (paraName) {
      let url = document.location.search
      let arrObj = url.split('?')
      if (arrObj.length > 1) {
        let arrPara = arrObj[1].split('&')
        let arr

        for (let i = 0; i < arrPara.length; i++) {
          arr = arrPara[i].split('=')

          if (arr !== null && arr[0] === paraName) {
            return arr[1]
          }
        }
        return ''
      } else {
        return ''
      }
    }
  },
  computed: {
    position () {
      return parseInt(this.$route.params.position.substr(0, 2)) + '/' + this.$route.params.position + '/' + (this.$i18n.locale === 'sc' ? 'tc' : (this.$i18n.locale === 'pt' ? 'po' : this.$i18n.locale === 'uz' ? 'en' : this.$i18n.locale))
    }
  },
  created () {
    this.title = this.$t('faq.p' + this.$route.params.answer)
    let temp = {
      '20': [ 21, 22, 23 ],
      '36': [ 37, 38, 39 ],
      '50': [ 51, ' ', 195, 196 ],
      '59': [ 60, 61, 62 ],
      '80': [ 81, 82, 83 ],
      '97': [ 98, 194, 99, 100 ],
      '108': [ 109, 110 ],
      '111': [ 112, 113, 114, 115, 116 ],
      '117': [ 118, 119 ],
      '120': [ 121, 122, 123 ],
      '128': [ 129, 130 ],
      '131': [ 132, 133, 134, 135, 136, 137, 138, 139, 140, 141, 142, 143 ],
      '148': [ 149, 150, 151, 152, 153 ],
      '155': [ 156, 157, 158, 159, 160 ],
      '161': [ 162, 163, 164, 165, 166, 167, 168, 169, 170, 171 ],
      '173': [ 174, 175 ],
      '183': [ 184, 185, 186 ]
    }

    let answer = temp[this.$route.params.answer] ? temp[this.$route.params.answer] : [ parseInt(this.$route.params.answer) + 1 ]
    let answerIndex = parseInt(this.$route.params.answer)
    if (answerIndex === 131) {
      this.lists = answer.filter((v, index) => index < 7).map(item => {
        return this.$t('faq.p' + item)
      })
      this.lists2 = answer.filter((v, index) => index > 6).map(item => {
        return this.$t('faq.p' + item)
      })
    } else if (answerIndex === 108) {
      this.lists = answer.filter((v, index) => index < 1).map(item => {
        return this.$t('faq.p' + item)
      })
      this.lists2 = answer.filter((v, index) => index > 0).map(item => {
        return this.$t('faq.p' + item)
      })
    } else if (answerIndex === 117) {
      this.lists = answer.filter((v, index) => index < 1).map(item => {
        return this.$t('faq.p' + item)
      })
      this.lists2 = answer.filter((v, index) => index > 0).map(item => {
        return this.$t('faq.p' + item)
      })
    } else if (answerIndex === 120) {
      this.lists = answer.filter((v, index) => index === 0).map(item => {
        return this.$t('faq.p' + item)
      })
      this.lists2 = answer.filter((v, index) => index === 1).map(item => {
        return this.$t('faq.p' + item)
      })
      this.lists3 = answer.filter((v, index) => index === 2).map(item => {
        return this.$t('faq.p' + item)
      })
    } else if (answerIndex === 128) {
      this.lists = answer.filter((v, index) => index === 0).map(item => {
        return this.$t('faq.p' + item)
      })
      this.lists2 = answer.filter((v, index) => index === 1).map(item => {
        return this.$t('faq.p' + item)
      })
    } else if (answerIndex === 161) {
      this.lists = answer.filter((v, index) => index < 5).map(item => {
        return this.$t('faq.p' + item)
      })
      this.lists2 = answer.filter((v, index) => index > 4).map(item => {
        return this.$t('faq.p' + item)
      })
    } else if (answerIndex === 20) {
      this.special = true
      this.lists = answer.filter((v, index) => index === 0).map(item => {
        return this.$t('faq.p' + item)
      })
      this.lists2 = answer.filter((v, index) => index === 1).map(item => {
        return this.$t('faq.p' + item)
      })
      this.lists3 = answer.filter((v, index) => index === 2).map(item => {
        return this.$t('faq.p' + item)
      })
    } else if (answerIndex === 50) {
      this.lists = answer.filter((v, index) => index < 3).map(item => {
        return item === ' ' ? ' ' : this.$t('faq.p' + item)
      })
      this.lists2 = answer.filter((v, index) => index > 2).map(item => {
        return this.$t('faq.p' + item)
      })
    } else {
      this.lists = answer.map(item => {
        return this.$t('faq.p' + item)
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.home {
  position: relative;
  padding: 40px 34px;
  .title {
    font-size: 30px;
    color: #242426;
    line-height: 38px;
    margin-bottom: 15px;
  }
  .van-hairline--bottom::after {
    border-color: #c5c7ca;
  }
  .content {
    padding-top: 15px;
    min-height: 800px;
    p {
      font-size: 28px;
      color: #535252;
      line-height: 38px;
      min-height: 38px;
    }
    .ans_img {
      width: 100%;
    }
    .special {
      width: auto;
      height: 55px;
      display: block;
    }
    .special_p1 {
      margin: 40px 0px 10px 0px;
    }
    .special_p2 {
      margin: 30px 0px 10px 0px;
    }
  }
  .feedback {
    position: relative;
    width: 100%;
    height: 100px;
    margin-top: 80px;
    margin-bottom: 80px;
    display: flex;
    justify-content: center;
    align-items: center;
    a {
      font-size: 0.4rem;
      color: #29cc96;
      text-decoration: none;
      border-bottom: 1px solid;
      cursor: pointer;
    }
  }
}
</style>
